import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import './AddModal.css';

function EditProfileModal({ profile, closeModal, onDataEdited }) {
  const [nomePerfil, setNomePerfil] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  
  useEffect(() => {
    if (profile) {
      setNomePerfil(profile["profile name"]);
    }
  }, [profile]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const { error: updateError } = await supabase
      .from('profiles')
      .update({ "profile name": nomePerfil })
      .eq('id', profile.id);
      
    if (updateError) {
      setError(updateError.message);
    } else {
      onDataEdited(); 
      closeModal();
    }
    setLoading(false);
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h2>Editar Perfil de Navegador</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nome do Perfil</label>
            <input 
              type="text" 
              value={nomePerfil} 
              onChange={(e) => setNomePerfil(e.target.value)} 
              required 
            />
          </div>
          {error && <p className="error-message">{error}</p>}
          <div className="modal-actions">
            <button type="button" onClick={closeModal} className="button-cancel">Cancelar</button>
            <button type="submit" className="button-save" disabled={loading}>
              {loading ? 'Salvando...' : 'Salvar Alterações'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditProfileModal;